import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import headerStyle from "assets/jss/material-kit-pro-react/components/headerStyle.js";

const NavBarStyle = theme => ({
    ...headerLinksStyle(theme),
    ...headerStyle(theme),
    transparentBackground: {

    },
    translucentBackground: {

    },
    logo: {
        width: 140,
    }
});

export default NavBarStyle;